import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'
import { route } from '../utils/routes'

export function PrivateRoute() {
    const { session } = useAuth()

    const location = useLocation()

    if (session?.sessionToken) {
        return <Outlet />
    }

    return (
        <Navigate
            to={{
                pathname: route('login'),
            }}
            state={{
                from: location,
            }}
        />
    )
}
